export const getRedirectToEnrollmentUrl = (
  updateCompanyButtonClicked: boolean
): string => {
  let url = '/businesstraveler?reenrollment=true';
  if (updateCompanyButtonClicked) {
    url = url + '&different=true';
  }
  return url;
};
